import React from "react";
import PropTypes from "prop-types";

import { getEltAndAccessor, getEltAndAccessorBytes } from "./common/helpers";
import DataGrid from "../../Components/DataGrid";
import { caseInsensitiveFilter } from "./common/ResourcesTable";

import "./common/ResourcesTable.scss";

/*
Constants and Helpers
*/

export const getRows = ({ data, onClickIp = () => () => {} }) => {
  const rows = data.map((elt) => {
    const {
      address: destination,
      groupedBytes: volume,
      destinationId,
      srcIpAddress: source,
      sourceIpId: sourceId,
    } = elt;

    // Destination
    const { accessor: destinationAccessor, element: destinationElt } =
      getEltAndAccessor({
        clickable: !!destinationId,
        label: destination,
        onClickElt: onClickIp(destinationId),
      });

    // Source
    const { accessor: sourceAccessor, element: sourceElt } = getEltAndAccessor({
      clickable: !!destinationId,
      label: source,
      onClickElt: onClickIp(sourceId),
    });

    // Volume
    const { accessor: volumeAccessor, element: volumeElt } =
      getEltAndAccessorBytes(volume);

    return {
      destination: destinationElt,
      destinationAccessor,

      source: sourceElt,
      sourceAccessor,

      volume: <div className="number-column">{volumeElt}</div>,
      volumeAccessor,
    };
  });

  return rows;
};

const COLUMNS = [
  {
    Header: "Source",
    accessor: "sourceAccessor",
    filterable: true,
    sortable: true,
    Cell: (row) => row.original.source,
    filterMethod: caseInsensitiveFilter(),
    maxWidth: 180,
    minWidth: 140,
  },
  {
    Header: "Destination",
    accessor: "destinationAccessor",
    filterable: true,
    sortable: true,
    Cell: (row) => row.original.destination,
    maxWidth: 180,
    minWidth: 140,
    filterMethod: caseInsensitiveFilter(),
  },
  {
    Header: <div className="number-column">Volume</div>,
    accessor: "volumeAccessor",
    filterable: false,
    sortable: true,
    Cell: (row) => row.original.volume,
    maxWidth: 80,
    minWidth: 80,
    filterMethod: caseInsensitiveFilter(),
  },
];

/*
Component
*/

const TalkersTable = (props) => {
  const { data } = props;

  return (
    <div className="resources-table">
      <DataGrid
        defaultPageSize={10}
        data={data}
        columns={COLUMNS}
        showPagination={false}
      />
    </div>
  );
};

TalkersTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})),
};

TalkersTable.defaultProps = {
  data: [],
};

export default TalkersTable;
